import ReedmakerConfig from "../../content/reedmaker.yaml"

/**
 * 
 * @param {*} formData 
 * @return Promise(boolean)
 */
const sendForm = async (formData) => {
    return await fetch(ReedmakerConfig.endpoint.reedmaker, {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: {
         "Content-type": 'application/x-www-form-urlencoded'
        }
    })
    .then(response => {
        return response.json()
    })
    .then(json => {
        console.log(json)
        return json.code === 200;
    })
    .catch(err => {
        console.log(err)
        return false;
    });
}

export {
    sendForm,
}